// test2586
(2586 && 0);
